import React, { useState } from 'react'
import PopOutModal from '../PopOutModal/PopOutModal'
import Button from '../ui/Button'
import styles from './DeleteAccountModal.module.css'

interface Props {
    isOpen: boolean
    onClose: () => void
}

const DeleteAccountModal: React.FC<Props> = ({ isOpen, onClose }) => {
    const [password, setPassword] = useState('')

    return (
        <PopOutModal
            title="Delete Account"
            isOpen={isOpen}
            onClose={onClose}
            clickOff={false}
            content={
                <div className={styles.content}>
                    <div className={styles.warning}>
                        <h2 className={styles.warningTitle}>
                            This action is permanent and cannot be undone
                        </h2>
                        <p className={styles.warningText}>
                            Deleting your account will permanently remove all
                            your data, contributions, and settings. Your account
                            cannot be recovered after this step.
                        </p>
                    </div>
                    <div className={styles.field}>
                        <label
                            htmlFor="deletePassword"
                            className={styles.label}
                        >
                            Password
                        </label>
                        <input
                            id="deletePassword"
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            className={styles.input}
                            placeholder="Enter your password to confirm"
                        />
                    </div>
                </div>
            }
            bottomContent={
                <div className={styles.bottomActions}>
                    <Button variant="secondary" onClick={onClose}>
                        Cancel
                    </Button>
                    <Button variant="primary" type="button">
                        Confirm Delete Account
                    </Button>
                </div>
            }
        />
    )
}

export default DeleteAccountModal
